<template>
    <div :class="addClass">
        <div class="form-item form-checkbox"
             :class="{ 'form-item--error': errors.has(name) && showErrors }">
            <input type="checkbox"
                   :name="name"
                   :id="'register_form_' + name"
                   v-validate
                   :checked="checked"
                   :data-vv-rules="rules"
                   :data-vv-as="label"
                   :disabled="progress"
                   @click="setValue()">
            <label :for="'register_form_' + name"
                   v-html="message"></label>
            <div class="check"></div>
            <p class="field-error--description field-error--description--white"
               v-show="errors.has(name) && showErrors">
                {{ errors.first(name) }}
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        inject: ['$validator'],
        props: ['addClass', 'checked', 'label', 'message', 'name', 'progress', 'rules', 'showErrors', 'updateValue'],
        data () {
            return {
                value: false
            }
        },
        methods: {
            setValue () {
                this.value = !(this.checked || this.value);
                this.updateValue(this.name, this.value);
            }
        },
        watch: {
            value () {
                this.updateValue(this.name, this.value);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/terms/fields/Checkbox.vue